import {createContext, useContext} from 'react';

import {type OptixTableProps} from './OptixTable.types';

export const OptixTableContext = createContext<OptixTableProps<unknown> | null>(
  null,
);

export const useOptixTableContext = (): OptixTableProps<unknown> => {
  const optixTableContext = useContext<OptixTableProps<unknown> | null>(
    OptixTableContext,
  );

  if (!optixTableContext) {
    throw new Error(
      'useOptixTableContext has to be used within <OptixTableContext.Provider>',
    );
  }

  return optixTableContext;
};
